import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import { checkToken } from 'utils/request';
import { UserRoles } from 'helpers/constants';

const PublicRoute = ({ component: Component, authorized, onboardingStatus, isAdmin, ...rest }) => {
  return (
    <Route
      {...rest}
      render={p => {
        if (!authorized) {
          return <Component {...p} />;
        }

        if (onboardingStatus === 'Registered') {
          return <Component {...p} />;
        }

        if (onboardingStatus === 'InfoAdded') {
          if (isAdmin) {
            return <Redirect to="/admin/contributions" />;
          }

          const { from } = p.location.state || {
            from: { pathname: '/dashboard' },
          };
          return <Redirect to={from} />;
        }
      }}
    />
  );
};

PublicRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.element, PropTypes.node, PropTypes.elementType]).isRequired,
  authorized: PropTypes.bool.isRequired,
  onboardingStatus: PropTypes.string.isRequired,
  isAdmin: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ account }) => ({
  authorized: checkToken(account?.token),
  onboardingStatus: account?.user?.onboardingStatus || '',
  isAdmin: account.roles.includes(UserRoles.admin), // current role
});

export default connect(mapStateToProps)(PublicRoute);
